import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck'

import { RealTimeEditingData } from './type'

export const realTimeEditingData: RealTimeEditingData = {
  headline: 'Don\'t love a page? Re-make it in seconds.',
  body: 'Every story is yours to fine-tune. Rewrite any line, refresh any illustration in seconds, rearrange spreads. Full creative control without the learning curve.',
  bulletPoints: [
    { text: 'Refresh any illustration in seconds', icon: faCheck },
    { text: 'Rewrite any text on any page', icon: faCheck },
    { text: 'Rearrange, add, or remove spreads', icon: faCheck },
  ],
  gifUrl: '/images/pixie-world-software-window.png',
  ctaText: 'Try the Pixie Editor',
  ctaLink: '/shop',
  supportText: 'Need help? Our team guides you through every step — reach out at support@pixieworldstore.com.',
}
